import React, { useState, useRef, useEffect } from 'react';

const SelectBox = ({ options, placeholder, className,name,value,onSendData,ulWidth,selectwidth}) => {
    const [query, setQuery] = useState(value || '');
    
    useEffect(() => {
        setQuery(value || '');
    }, [value]);
    const [isOpen, setIsOpen] = useState(false);
    const [filteredOptions, setFilteredOptions] = useState([]);
    const dropdownRef = useRef(null);

    const handleInputChange = (e) => {
        const value = e.target.value;
        setQuery(value);
        setFilteredOptions(options.filter(option =>
            option.toLowerCase().includes(value.toLowerCase())
        ));
    };

    const handleOptionClick = (option) => {
        setQuery(option);
        setIsOpen(false);
        setOpenInputSelect(false);
        onSendData(option);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
            setOpenInputSelect(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const [openInputSelect, setOpenInputSelect] = useState(false);

    return (
        <div className={`w-[${selectwidth}px] p-0}`}>
            <div className="relative text-[14px] inline-block w-full rounded focus-within:ring-1 focus-within:ring-blue-500" ref={dropdownRef}>
                <div className='flex bg-[white] border border-[#dcdfe6] rounded box-border'>
                    <input
                        type="text"
                        name={name}
                        placeholder={placeholder}
                        className={`w-full bg-white inline-block text-inherit h-[40px] leading-[40px] outline-none px-[15px] cursor-pointer ${className}`}
                        value={query}
                        onChange={handleInputChange}
                        onClick={() => { setIsOpen(!isOpen); setOpenInputSelect(!openInputSelect); }}
                        readOnly
                    />
                    <div className='flex flex-col justify-center mr-[5px]'>
                        {openInputSelect === false ?
                            <svg
                                className="w-5 h-5 outline-none"
                                focusable="false"
                                viewBox="0 0 24 24"
                                data-testid="KeyboardArrowDownIcon"
                                tabIndex="-1"
                                title="KeyboardArrowDown"
                                fill='#c0c4cc'
                            >
                                <path d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"></path>
                            </svg>
                            :
                            <svg
                                className="w-5 h-5 outline-none"
                                focusable="false"
                                viewBox="0 0 24 24"
                                data-testid="KeyboardArrowUpIcon"
                                tabIndex="-1"
                                title="KeyboardArrowUp"
                                fill='#c0c4cc'
                            >
                                <path d="M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z"></path>
                            </svg>
                        }
                    </div>
                </div>
                {isOpen && (
                    <ul style={{
                        marginTop: '5px',
                        padding: '0',
                        listStyleType: 'none',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        maxHeight: '200px',
                        overflowY: 'auto',
                        position: 'absolute',
                        backgroundColor: 'white',
                        width: `${ulWidth !== undefined ? ulWidth : 100}%`,
                        fontSize: '12px',
                        whiteSpace:'nowrap',
                        zIndex: 1
                    }}>
                        {filteredOptions.length > 0 ? (
                            filteredOptions.map((option, index) => (
                                <li
                                    key={index}
                                    onClick={() => handleOptionClick(option)}
                                    style={{
                                        padding: '10px',
                                        cursor: 'pointer',
                                        backgroundColor: '#fff'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f1f1f1'}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#fff'}
                                >
                                    {option}
                                </li>
                            ))
                        ) : (
                            options.map((option, index) => (
                                <li
                                    key={index}
                                    onClick={() => index !== 0 && handleOptionClick(option)}
                                    style={{
                                        cursor: 'pointer',
                                        backgroundColor: '#fff',
                                        paddingLeft: '10px',
                                        paddingTop: '10px',
                                        paddingBottom: '10px',
                                        height:'35px'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f1f1f1'}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#fff'}
                                >
                                    {option}
                                </li>
                            ))
                        )}
                    </ul>
                )}
            </div>
        </div>
    );
};

export default SelectBox;